import {
  Box,
  Container,
  SimpleGrid,
  Heading,
  Text,
  Icon,
  Stack,
} from "@chakra-ui/react";
import {
  ClipboardText,
  ChatCircleText,
  Trophy,
  UsersThree,
  MagnifyingGlass,
} from "phosphor-react";

const Feature = ({
  title,
  text,
  icon,
}: {
  title: string;
  text: string;
  icon: React.ElementType;
}) => {
  return (
    <Stack
      align="center"
      textAlign="center"
      p={8}
      rounded="xl"
      bg="oxygon.dark.200"
      border="1px solid"
      borderColor="oxygon.dark.300"
      _hover={{
        transform: "translateY(-5px)",
        transition: "all 0.3s",
        borderColor: "oxygon.primary",
      }}
      data-aos="fade-up"
    >
      <Box
        rounded="full"
        p={2}
        bg="oxygon.dark.300"
        color="oxygon.primary"
        mb={4}
      >
        <Icon as={icon} w={10} h={10} />
      </Box>
      <Heading size="md" mb={4}>
        {title}
      </Heading>
      <Text color="gray.400">{text}</Text>
    </Stack>
  );
};

const Features = () => {
  return (
    <Box py={20} bg="oxygon.dark.100">
      <Container maxW="container.xl">
        <Stack spacing={12}>
          <Stack textAlign="center" spacing={4} data-aos="fade-up">
            <Heading
              bgGradient="linear(to-r, oxygon.primary, oxygon.secondary)"
              bgClip="text"
            >
              What is Virtual Golf Society?
            </Heading>
            <Text color="gray.400" maxW="800px" mx="auto">
              Virtual Golf Society (VGS) is a social and competitive platform
              built specifically for indoor and simulator golfers. Post rounds,
              join challenges, play in multi-round tournaments, and manage your
              own clubs — whether you play at home, in a sim school, or at your
              local indoor facility. VGS is simulator software and launch
              monitor agnostic.
            </Text>
          </Stack>

          <SimpleGrid columns={{ base: 1, md: 2, lg: 5 }} spacing={8}>
            <Feature
              icon={ClipboardText}
              title="Round Tracking & Posting"
              text="Start, track, and close simulator rounds with all relevant context, then share them to your feed."
            />
            <Feature
              icon={ChatCircleText}
              title="Social Feed"
              text="A centralized feed showing activity from you, your friends, and the wider sim golf community."
            />
            <Feature
              icon={Trophy}
              title="Tournaments & Tours"
              text="Play structured multi-round tournaments and tours with clear rules, locked settings, and leaderboards."
            />
            <Feature
              icon={UsersThree}
              title="Clubs & Communities"
              text="Create and manage clubs, divisions, and teams, and run your own events for members."
            />
            <Feature
              icon={MagnifyingGlass}
              title="Discover"
              text="Find the latest trends on simulator tech, equipment, courses, and what the community is talking about."
            />
          </SimpleGrid>
        </Stack>
      </Container>
    </Box>
  );
};

export default Features;
